// Monta o payload do PUT /products/colors/:colorId a partir do campo
// editado na grade de cores. O backend grava só os campos enviados.
export const buildColorUpdate = (field, value) => {
  const text = String(value ?? "").trim();

  if (field === "label") {
    if (!text) return { ok: false, msg: "Informe a descrição da cor!" };
    return { ok: true, payload: { label: text } };
  }

  if (field === "rgb") {
    return { ok: true, payload: { rgb: text } };
  }

  return { ok: false, msg: "Campo inválido!" };
};
